import { render, staticRenderFns } from "./RevisionsAlert.vue?vue&type=template&id=134532a8&"
import script from "./RevisionsAlert.vue?vue&type=script&lang=js&"
export * from "./RevisionsAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports